import React from 'react'
import { Input } from 'antd'
import { observer } from 'mobx-react-lite'
import type { FieldMethods } from '../types'

export interface PasswordInputProps {
    field?: FieldMethods
    index?: number
    disabled?: boolean
    className?: string
    style?: React.CSSProperties
    [key: string]: any
}

export const PasswordInput: React.FC<PasswordInputProps> = observer(({ field, index }) => {
    if (!field) {
        return null
    }

    return <Input.Password autoComplete="new-password" {...field.bind({ index: index ?? 0 })} />
})
